import { useQuery, useQueryClient } from '@tanstack/react-query';
import apiService from '../services/api.service';
import { useRealtime } from '../contexts/RealtimeContext';
import { CategoryGroup } from '../types';

export const categoryGroupsQueryKey = (eventId: string | null) => ['category-groups', eventId] as const;

/** Groupes de catégories de l'événement. On écoute aussi `category` : un
 *  groupe n'est qu'une combinaison de catégories, il se relit faux si l'une
 *  d'elles change. */
export function useCategoryGroups(eventId: string | null) {
  const qc = useQueryClient();
  useRealtime(['category_group', 'category'], () => {
    if (eventId) qc.invalidateQueries({ queryKey: categoryGroupsQueryKey(eventId) });
  });
  return useQuery({
    queryKey: categoryGroupsQueryKey(eventId),
    queryFn: async () => ((await apiService.get(`/events/${eventId}/category-groups`)).data.category_groups || []) as CategoryGroup[],
    enabled: !!eventId,
    staleTime: 30 * 1000,
  });
}
